import React from 'react'
import LogoClicksign from '@resources/imgs/logo-empresa.png'
import { formatOrderDate } from '../../utils/formatOrderDate'
import './ContractStatus.css'

interface RefusedContractStatusProps {
  refused_at?: Date | null
}

const RefusedContractStatus: React.FC<RefusedContractStatusProps> = ({ refused_at }) => {
  return (
    <div className="contract-status-container">
      <div className="d-flex align-items-start gap-4">
        <div className="clicksign-logo-box bg-danger-subtle">
          <img src={LogoClicksign} alt="Clicksign" />
        </div>

        <div className="flex-grow-1">
          <div className="status-header mb-3">
            <span className="status-icon text-danger me-2" style={{ fontSize: '1.5rem' }}>✗</span>
            <h5 className="d-inline mb-0 text-danger">Contrato recusado</h5>
          </div>
          <p className="text-muted mb-4">
            Recusado em <strong>{formatOrderDate(refused_at ?? undefined)}</strong>
          </p>

          <div className="alert alert-danger d-flex gap-3 mb-0" style={{ backgroundColor: '#FEF3F2', border: '1px solid #FECDCA' }}>
            <div style={{ fontSize: '1.5rem' }}>❌</div>
            <div className="flex-grow-1">
              <p className="mb-0" style={{ color: '#B42318' }}>
                O contrato foi recusado. Entre em contato com nossa Central de Atendimento para mais informações.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RefusedContractStatus
